import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

class ReceptoresExcelInfoData extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">RFC: </strong>
          { data.rfc }
          <br/>

          <strong className="text-info card-label-info">Razón Social: </strong>
          { data.razon_social }
          <br/>

          <strong className="text-info card-label-info">Uso CFDI: </strong>
          { data.uso_cfdi }
          <br/>

          <strong className="text-info card-label-info">Régimen: </strong>
          { data.regimen }
          <br/>

          <strong className="text-info card-label-info">Email: </strong>
          { data.email }
          <br/>

          <strong className="text-info card-label-info">Teléfono: </strong>
          { data.telefono }
          <br/>

          <strong className="text-info card-label-info">Comentario: </strong>
          { data.comentario }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default ReceptoresExcelInfoData;